import {
  EyeOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Row, Space, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const VendorDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { vendorClientId } = useParams();
  const dataSource = [
    {
      key: "1",
      bidName: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      bidName: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "Bid Id",
      dataIndex: "bidId",
      key: "bidId",
      width: "10%",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
    },
    {
      title: "Bid Name",
      dataIndex: "bidName",
      key: "bidName",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
    },
    {
      title: "Bid Start Date",
      dataIndex: "bidStartDate",
      key: "bidStartDate",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
    },
    {
      title: "Bid End Date",
      dataIndex: "bidSumbitDate",
      key: "bidSumbitDate",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
    },
    {
      title: "Bid Applied",
      dataIndex: "status",
      key: "status",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      onHeaderCell: () => ({
        style: { backgroundColor: "#E9F8FF", color: "#333" },
      }),
      render: () => (
        <>
          <Space>
            <Button
              style={{ padding: "1px 5px" }}
              // onClick={() => setIsModelOpen(true)}
              size="small"
            >
              <EyeOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        <div style={{ margin: "20px 0px" }}>
          <Row gutter={20}>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={6}
              style={{ marginBottom: "10px" }}
            >
              <Card
                size="small"
                style={{
                  position: "relative",
                  paddingTop: "0px",
                  borderColor: " var(--Border-colorBorder, #D9D9D9)",
                  // borderWidth: "0.1px",
                  borderStyle: "solid",
                }}
                headStyle={{ backgroundColor: "white" }}
                type="inner"
                extra={
                  <>
                    <p
                      style={{
                        paddingLeft: "14px",
                        fontSize: "14px",
                        fontWeight: "300",
                        paddingTop: "10px",
                      }}
                    >
                      Bids
                    </p>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        textAlign: "end",
                        paddingBottom: "6px",
                      }}
                    >
                      281
                    </p>
                  </>
                }
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-0px",
                    left: "15px",
                    transform: "translateY(-50%)",
                    fontSize: "20px",
                    background:
                      "linear-gradient(180deg, #3E3D45 0%, #202020 100%)",
                    color: "white",
                    padding: "14px 20px",
                    borderRadius: "10px",
                    marginTop: "15px",
                  }}
                >
                  <UnorderedListOutlined />
                </div>

                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  Total Participated bidding
                </p>
              </Card>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={6}
              style={{ marginBottom: "20px" }}
            >
              <Card
                size="small"
                style={{
                  position: "relative",
                  paddingTop: "0px",
                  borderColor: " var(--Border-colorBorder, #D9D9D9)",
                  // borderWidth: "0.1px",
                  borderStyle: "solid",
                }}
                type="inner"
                headStyle={{ backgroundColor: "white" }}
                extra={
                  <>
                    <p
                      style={{
                        paddingLeft: "14px",
                        fontSize: "14px",
                        fontWeight: "300",
                        paddingTop: "10px",
                      }}
                    >
                      Successful Bids
                    </p>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        textAlign: "end",
                        paddingBottom: "6px",
                      }}
                    >
                      23
                    </p>
                  </>
                }
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-0px",
                    left: "15px",
                    transform: "translateY(-50%)",
                    fontSize: "20px",
                    background:
                      "linear-gradient(180deg, #E93B77 0%, #DA1F63 100%)",

                    color: "white",
                    padding: "14px 20px",
                    borderRadius: "10px",
                    marginTop: "15px",
                  }}
                >
                  <FileDoneOutlined />
                </div>

                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  Total Successful Bidding
                </p>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={6}>
              <Card
                size="small"
                style={{
                  position: "relative",
                  paddingTop: "0px",
                  borderColor: " var(--Border-colorBorder, #D9D9D9)",
                  // borderWidth: "0.1px",
                  borderStyle: "solid",
                }}
                type="inner"
                headStyle={{ backgroundColor: "white" }}
                extra={
                  <>
                    <p
                      style={{
                        paddingLeft: "14px",
                        fontSize: "14px",
                        fontWeight: "300",
                        paddingTop: "10px",
                      }}
                    >
                      PO’s
                    </p>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        textAlign: "end",
                        paddingBottom: "6px",
                      }}
                    >
                      22
                    </p>
                  </>
                }
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-0px",
                    left: "15px",
                    transform: "translateY(-50%)",
                    fontSize: "20px",
                    background:
                      "linear-gradient(180deg, #63B967 0%, #4BA64F 100%)",
                    color: "white",
                    padding: "14px 20px",
                    borderRadius: "10px",
                    marginTop: "15px",
                  }}
                >
                  <FileTextOutlined />
                </div>

                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  Total PO Received
                </p>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={6}>
              <Card
                size="small"
                style={{
                  position: "relative",
                  paddingTop: "0px",
                  borderColor: " var(--Border-colorBorder, #D9D9D9)",
                  // borderWidth: "0.1px",
                  borderStyle: "solid",
                }}
                type="inner"
                headStyle={{ backgroundColor: "white" }}
                extra={
                  <>
                    <p
                      style={{
                        paddingLeft: "30px",
                        fontSize: "14px",
                        fontWeight: "300",
                        paddingTop: "10px",
                      }}
                    >
                      Status
                    </p>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        textAlign: "end",
                        paddingBottom: "6px",
                      }}
                    >
                      Active
                    </p>
                  </>
                }
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-0px",
                    left: "15px",
                    transform: "translateY(-50%)",
                    fontSize: "20px",
                    background:
                      "linear-gradient(180deg, #439DEE 0%, #1E78E9 100%)",
                    color: "white",
                    padding: "14px 20px",
                    borderRadius: "10px",
                    marginTop: "15px",
                  }}
                >
                  <UserOutlined />
                </div>

                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  Account Status
                </p>
              </Card>
            </Col>
          </Row>
          <div style={{ marginTop: "35px" }}>
            <Card
              size="small"
              type="inner"
              // style={{ height: "100%" }}
              style={{
                position: "relative",
                paddingTop: "0px",
                borderColor: " var(--Border-colorBorder, #D9D9D9)",
                // borderWidth: "0.1px",
                borderStyle: "solid",
              }}
            >
              <h3 style={{ fontSize: "20px", fontWeight: "600" }}>
                Recent Bids
              </h3>
              <Table
                columns={columns}
                dataSource={dataSource}
                size="middle"
                style={{ marginTop: "10px" }}
                pagination={false}
              />
              <Row justify={"end"}>
                <Col>
                  <Button
                    style={{
                      background: "#058BC9",
                      marginTop: "20px",
                      color: "white",
                    }}
                    onClick={() =>
                      navigate(`/vendor/clients/${vendorClientId}/bid`)
                    }
                  >
                    View All Bids
                  </Button>
                </Col>
              </Row>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorDashboard;
